//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import addBuycar from '../buycar/add.vue'
import stVideo from '../common/stVideo.vue'
import historyBackJS from "../common/historyBack";
export default {
    components: {
        addBuycar, stVideo
    },
    mixins: [historyBackJS],
    data() {
        return {
            goods: {
                photos: []
            }
        }
    },
    watch: {
        token(newVal) {
            if(newVal) {
                this.loadDetail();
            } else {
                this.goods = {
                    photos: []
                }
            }
        }
    },
    computed: {
        token() {
            return this.$store.state.token;
        },
        carBadge() {
            return this.$store.state.carBadge;
        }
    },
    methods: {
        goBack(replace = false) {
            if(replace) {
                if(this.backPath) {
                    this.$router.replace(this.backPath);
                } else {
                    this.$router.replace('/goods');
                }
            } else {
                if(this.backPath) {
                    this.$router.push(this.backPath);
                } else {
                    this.$router.push('/goods');
                }
            }
        },
        toLink(path) {
            if(path == '/customer') {
                // this.$store.state.customerToGoods = this.goods
                sessionStorage.setItem("customerToGoods", JSON.stringify(this.goods));
                this.$router.push(path);
            } else {
                this.$router.push(path);
            }
        },
        readyBuy(type) {
            this.$refs.addBuycarRef.openPopup(this.goods, type);
        },
        loadDetail() {
            let that = this; 
            that.$vux.loading.show({
                text: '加载中...'
            });
            that.$axios.get('/api/v1.0/lonbonShop/goodsDetails', {
                params: {
                    goodsId: that.goodsId
                }
            }).then(function (response) {
                if(response.status == 200) {
                    let one = response.body;
                    let photos = []; let videos = []; let details = [];
                    one.photo.forEach((item) => {
                        var file = {
                            id: item.goodsPhotoId,
                            url: sessionStorage.fileURL + item.photo,
                            file: null,
                            status: 1,
                            remotePath: item.photo
                        }
                        if(item.photoType == 0) {
                            photos.push(file);
                        }
                        if(item.photoType == 1) {
                            videos.push(file);
                        }
                        if(item.photoType == 2) {
                            details.push(file);
                        }
                    })
                    one.photos = photos; one.videos = videos; one.details = details;
                    one.poster = one.photos[0].remotePath;
                    that.goods = one;

                    setTimeout(() => {
                        that.$store.state.APPPAGE.shareHandle({
                            title: one.goodsName,
                            desc: one.shareDetail,
                            link: sessionStorage.domainURL + '/LonBonStore/#/goodsDetail?goodsId='+one.goodsId,
                            imgUrl: one.photos[0].url
                        }) 
                    }, 1500);
                }
                that.$vux.loading.hide(); 
            }).catch(function() {
                that.$vux.loading.hide(); 
            })
        }
    },
    beforeRouteLeave (to, from, next) {
        this.$store.state.APPPAGE.shareHandle();
        next();
    },
    mounted() {
        this.goodsId = this.$route.query.goodsId;
        this.backPath = this.$route.query.backPath;
        if(this.goodsId) {
            this.loadDetail();
        } else {
            this.goBack();
        }
        setTimeout(() => {
            $(".viewer-container").click(() => {
                this.$el.querySelector('.goods-photos').$viewer.hide();;
            })
        }, 1000);
    }
}



// WEBPACK FOOTER //
// ./src/components/goods/detail.vue